module.exports = __webpack_public_path__ + "googlelogo.svg?686f8efa6e3e28e96d1c08399e8d353d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/googlelogo.svg
// module id = 1307
// module chunks = 2